<div
  class="flex flex-col gap-12 w-full h-full items-center justify-center pt-10"
>
  <div
    class="flex flex-col items-center justify-center border-4 border-blue-300 w-24 h-24 rounded-full"
  >
    <svg-icon src="assets/icons/check.svg" svgClass="h-14 w-14 text-blue-100" />
  </div>

  <h1 class="font-bold text-4xl text-light-300 text-center">
    Thank you for registering with Seedio!
  </h1>
  <p class="text-xl text-light-300 text-center">
    Ready to dive in?<br />Log in and start exploring!
  </p>

  <p-button
    severity="primary"
    type="submit"
    label="Login"
    size="large"
    (onClick)="onReturnToLoginPage()"
  />
</div>
